import { PathSegmentResolver } from '../../utils/use-path';

export const resolveLinksPath: PathSegmentResolver = ({ defaultLink }) => {
  return {
    title: 'Länkar',
    isPageTitle: true,
    link: defaultLink,
  };
};
